var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9697 3.21967C12.6768 3.51257 12.6768 3.98743 12.9697 4.28033L13.9394 5.25H9.75C8.09317 5.25 6.75 6.59315 6.75 8.25V9C6.75 9.41423 7.08579 9.75 7.5 9.75C7.91423 9.75 8.25 9.41423 8.25 9V8.25C8.25 7.42157 8.92155 6.75 9.75 6.75H13.9394L12.9697 7.71968C12.6768 8.01255 12.6768 8.48745 12.9697 8.78033C13.2626 9.0732 13.7374 9.0732 14.0303 8.78033L16.2803 6.53033C16.5732 6.23744 16.5732 5.76257 16.2803 5.46967L14.0303 3.21967C13.7374 2.92678 13.2626 2.92678 12.9697 3.21967ZM10.5 8.25C10.0858 8.25 9.75 8.58578 9.75 9V9.75C9.75 10.5785 9.07845 11.25 8.25 11.25H4.06066L5.03033 10.2803C5.32322 9.98745 5.32322 9.51255 5.03033 9.21968C4.73743 8.9268 4.26257 8.9268 3.96967 9.21968L1.71967 11.4697C1.42678 11.7626 1.42678 12.2375 1.71967 12.5303L3.96967 14.7803C4.26257 15.0732 4.73743 15.0732 5.03033 14.7803C5.32322 14.4875 5.32322 14.0126 5.03033 13.7197L4.06066 12.75H8.25C9.90683 12.75 11.25 11.4068 11.25 9.75V9C11.25 8.58578 10.9142 8.25 10.5 8.25Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchProfile);
export default __webpack_public_path__ + "static/media/switch-profile.86f004808a48568aacd43a77bca9d3c1.svg";
export { ForwardRef as ReactComponent };